import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface ExpertState {
  expertCode: string | null;
  registrationData: {
    fullName: string;
    email: string;
    phone: string;
    categoryId: string;
    categoryName: string;
    subCategoryId: string;
    subCategoryName: string;
  } | null;
}

const initialState: ExpertState = {
  expertCode: null,
  registrationData: null,
};

export const expertSlice = createSlice({
  name: 'expert',
  initialState,
  reducers: {
    // Action to store the unique expert code (from onboarding status API)
    setExpertCode: (state, action: PayloadAction<string>) => {
      state.expertCode = action.payload;
    },
    // Action to store form data from the signup step
    setRegistrationData: (state, action: PayloadAction<ExpertState['registrationData']>) => {
      state.registrationData = action.payload;
    },
    // Reset the store (useful for logging out or restarting the flow)
    clearRegistrationData: (state) => {
      state.registrationData = null;
      state.expertCode = null;
    },
  },
});

// Export all actions
export const { setExpertCode, setRegistrationData, clearRegistrationData } = expertSlice.actions;

// Export the reducer as default
export default expertSlice.reducer;